<template>
  <el-form :inline="true" class="mainSearch">
    <el-page-header @back="goback" style="margin-bottom: 20px">
      <template #content>
        <span class="text-large font-600 mr-3">{{ title }} </span>
      </template>
    </el-page-header>
  </el-form>
  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
      <el-row :gutter="20">
        <el-col :span="18"
          ><div class="grid-content ep-bg-purple">
            订单状态：
            <el-tag class="ml-2" round type="danger">{{
              util.showOrderStatus(orderInfo.orderstatus)
            }}</el-tag><br/><br/>
            客户对账状态：
            <el-tag class="ml-2" round type="success">{{
              util.showVerifyStatus(orderInfo.orderVerify.cusstatus)
            }}</el-tag>
            客户结算状态：
            <el-tag class="ml-2" round type="success">{{
              util.showVerifySetStatus(orderInfo.orderVerify.cussetstatus)
            }}</el-tag>
            供应商对账状态：
            <el-tag class="ml-2" round>{{
              util.showVerifyStatus(orderInfo.orderVerify.supstatus)
            }}</el-tag>
            供应商结算状态：<el-tag class="ml-2" round>{{
              util.showVerifySetStatus(orderInfo.orderVerify.supsetstatus)
            }}</el-tag>
          </div></el-col
        >
        <el-col :span="6"
          ><div class="grid-content ep-bg-purple" style="text-align:right">
            <el-button type="primary" @click="showFinanceCustomerDialog" v-hasPermission="['finance:edit']"><el-icon class="elicon"><EditPen /></el-icon>客户对账</el-button>
            <el-button type="danger" @click="showFinanceSupplierDialog" v-hasPermission="['finance:edit']"><el-icon class="elicon"><EditPen /></el-icon>供应商对账</el-button>
          </div></el-col
        >
      </el-row>

      <el-divider />
      <el-descriptions title="客户对账信息" :column="2">
        <el-descriptions-item label="客户对账状态">{{
          util.showVerifyStatus(orderInfo.orderVerify.cusstatus)
        }}</el-descriptions-item>
        <el-descriptions-item label="客户对账时间">{{
          util.formatDateUnix(orderInfo.orderVerify.cuspaided, "yyyy-MM-dd hh:mm")
        }}</el-descriptions-item>
        <el-descriptions-item label="差异补偿金额">¥ {{
          orderInfo.orderVerify.cuscompensation
        }}</el-descriptions-item>
        <el-descriptions-item label="客户结算状态">{{
          util.showVerifySetStatus(orderInfo.orderVerify.cussetstatus)
        }}</el-descriptions-item>
        <el-descriptions-item label="应收金额">¥ {{
          orderInfo.orderVerify.cuspaidamount
        }}</el-descriptions-item>
        <!-- <el-descriptions-item label="收款日期">{{
         util.formatDateUnix(orderInfo.orderVerify.cuspaided, "yyyy-MM-dd hh:mm")
        }}</el-descriptions-item> -->
        <el-descriptions-item label="收款开票">{{
          util.showYesNo(orderInfo.orderVerify.cusistax)
        }}</el-descriptions-item>
        <el-descriptions-item label="客户对账备注">{{
          orderInfo.orderVerify.cusnote
        }}</el-descriptions-item>
      </el-descriptions>
      <el-divider />
      <el-descriptions title="供应商对账信息" :column="2">
        <el-descriptions-item label="供应商对账状态">{{
          util.showVerifyStatus(orderInfo.orderVerify.supstatus)
        }}</el-descriptions-item>
        <el-descriptions-item label="供应商对账时间">{{
          util.formatDateUnix(orderInfo.orderVerify.suppayed, "yyyy-MM-dd hh:mm")
        }}</el-descriptions-item>
        <el-descriptions-item label="差异补偿金额">¥ {{
          orderInfo.orderVerify.supcompensation
        }}</el-descriptions-item>
        <el-descriptions-item label="供应商结算状态">{{
          util.showVerifySetStatus(orderInfo.orderVerify.supsetstatus)
        }}</el-descriptions-item>
        <el-descriptions-item label="应付金额">¥ {{
          orderInfo.orderVerify.suppayamount
        }}</el-descriptions-item>
        <!-- <el-descriptions-item label="付款日期">{{
         util.formatDateUnix(orderInfo.orderVerify.suppayed, "yyyy-MM-dd hh:mm")
        }}</el-descriptions-item> -->
        <el-descriptions-item label="付款开票">{{
          util.showYesNo(orderInfo.orderVerify.supistax)
        }}</el-descriptions-item>
        <el-descriptions-item label="供应商对账备注">{{
          orderInfo.orderVerify.supnote
        }}</el-descriptions-item>
      </el-descriptions>
      <el-divider />
      <el-descriptions title="订单基本信息" :column="2">
        <el-descriptions-item label="平台交易时间">{{
          util.formatDateUnix(orderInfo.platformed, "yyyy-MM-dd hh:mm")
        }}</el-descriptions-item>
        <el-descriptions-item label="商贾导入时间">{{
          util.formatDateUnix(orderInfo.created, "yyyy-MM-dd hh:mm")
        }}</el-descriptions-item>
        <el-descriptions-item label="平台订单号">{{
          orderInfo.platformnum
        }}</el-descriptions-item>
        <el-descriptions-item label="商贾订单号">{{
          orderInfo.ordernum
        }}</el-descriptions-item>
        <el-descriptions-item label="订单类型">{{
          util.showOrderType(orderInfo.ordertype)
        }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">{{
          util.showOrderStatus(orderInfo.orderstatus)
        }}</el-descriptions-item>
        <el-descriptions-item label="收货人姓名">{{
          orderInfo.orderAddress.receiver
        }}</el-descriptions-item>
        <el-descriptions-item label="收货人电话">{{
          orderInfo.orderAddress.receiverphone
        }}</el-descriptions-item>
        <el-descriptions-item label="收货地址" :span="2">{{
          orderInfo.orderAddress.receiveraddress
        }}</el-descriptions-item>
        <el-descriptions-item label="订单完成时间"><span v-if="orderInfo.completed">{{
          util.formatDateUnix(orderInfo.completed, "yyyy-MM-dd hh:mm")
        }}</span></el-descriptions-item>
        <el-descriptions-item label="订单备注">{{
          orderInfo.ordernote
        }}</el-descriptions-item>
      </el-descriptions>
      <el-divider />
      <el-descriptions title="订单金额信息" :column="2">
        
        <el-descriptions-item label="销售金额"
          >¥ {{ orderInfo.saleamount }}</el-descriptions-item
        >
        <el-descriptions-item label="成本金额"
          >¥ {{ orderInfo.costamount }}</el-descriptions-item
        >
        <el-descriptions-item label="实发数量"
          >{{ orderInfo.realqty }}</el-descriptions-item
        >
        <el-descriptions-item label="毛利额"
          >¥ {{ orderInfo.maolieamount }}</el-descriptions-item
        >
        <el-descriptions-item label="毛利率"
          >{{ orderInfo.maoliv }}
          <el-tag
            round
            :type="
              orderInfo.maoliv >= orderInfo.customer.maoliv &&
              orderInfo.maoliv <= orderInfo.customer.maolivge
                ? 'success'
                : 'danger'
            "
            disable-transitions
            ><span
              v-text="
                util.showOrderMaoliv(
                  orderInfo.maoliv >= orderInfo.customer.maoliv &&
                    orderInfo.maoliv <= orderInfo.customer.maolivge
                    ? 1
                    : 2
                )
              "
            ></span> </el-tag
        ></el-descriptions-item>
      </el-descriptions>
      <el-divider />
      <el-descriptions title="订单商品信息" :column="2">
        <el-descriptions-item label="供应商商品ID">{{
          orderInfo.orderGoods.sgoodsnum
        }}</el-descriptions-item>
        <el-descriptions-item label="商品ID">{{
          orderInfo.orderGoods.goodsnum
        }}</el-descriptions-item>
        <el-descriptions-item label="商品名称">{{
          orderInfo.name
        }}</el-descriptions-item>
        <el-descriptions-item label="商品类目">{{
          orderInfo.orderGoods.catalogname
        }}</el-descriptions-item>
        <el-descriptions-item label="商品品牌">{{
          orderInfo.orderGoods.brandname
        }}</el-descriptions-item>
        <el-descriptions-item label="商品规格">{{
          orderInfo.orderGoods.specification
        }}</el-descriptions-item>
        <el-descriptions-item label="商品描述">{{
          orderInfo.orderGoods.desc
        }}</el-descriptions-item>
        <el-descriptions-item label="税收编码">{{
          orderInfo.orderGoods.taxcode
        }}</el-descriptions-item>
        <el-descriptions-item label="税收分类名称">{{
          orderInfo.orderGoods.taxsort
        }}</el-descriptions-item>
        <el-descriptions-item label="国际条形码">{{
          orderInfo.orderGoods.barcode
        }}</el-descriptions-item>
        <el-descriptions-item label="电商评价数">{{
          orderInfo.orderGoods.erate
        }}</el-descriptions-item>
        <el-descriptions-item label="电商链接">{{
          orderInfo.orderGoods.elink
        }}</el-descriptions-item>
        <el-descriptions-item label="备注1">{{
          orderInfo.orderGoods.note1
        }}</el-descriptions-item>
        <el-descriptions-item label="备注2">{{
          orderInfo.orderGoods.note2
        }}</el-descriptions-item>
        <el-descriptions-item label="产地">{{
          orderInfo.orderGoods.producer
        }}</el-descriptions-item>
        <el-descriptions-item label="发货地">{{
          orderInfo.orderGoods.delivery
        }}</el-descriptions-item>
        <el-descriptions-item label="发货快递">{{
          orderInfo.orderGoods.express
        }}</el-descriptions-item>
        <el-descriptions-item label="成本价"
          >¥ {{ orderInfo.orderGoods.costprice }}</el-descriptions-item
        >
        <el-descriptions-item label="市场价"
          >¥ {{ orderInfo.orderGoods.marketprice }}</el-descriptions-item
        >
        <el-descriptions-item label="商品折扣"
          >{{ orderInfo.orderGoods.discount*100 }}%</el-descriptions-item
        >
      </el-descriptions>
      <el-divider />
      <el-descriptions title="订单发货信息" :column="2">
        <el-descriptions-item label="快递单号"><el-link :href="'https://m.kuaidi100.com/app/query/?coname=cg&nu='+orderInfo.orderAddress.expressnum" target="_blank" type="primary">{{ orderInfo.orderAddress.expressnum }}</el-link></el-descriptions-item>
        <el-descriptions-item label="快递公司">{{
          orderInfo.orderAddress.expresscompany
        }}</el-descriptions-item>
        <el-descriptions-item label="发货时间">{{
          util.formatDateUnix(
            orderInfo.orderAddress.deliveryed,
            "yyyy-MM-dd hh:mm"
          )
        }}</el-descriptions-item>
        <el-descriptions-item label="运费金额"
          >¥ {{ orderInfo.orderAddress.freightamount }}</el-descriptions-item
        >
        <el-descriptions-item label="发货备注"
          >{{ orderInfo.orderAddress.deliverynote }}
        </el-descriptions-item>
      </el-descriptions>
      <el-divider v-if="orderInfo.orderSales"/>
      <el-descriptions title="订单售后信息" :column="2" v-if="orderInfo.orderSales">
        <el-descriptions-item label="申请时间">
          {{
            util.formatDateUnix(
              orderInfo.orderSales.applyed,
              "yyyy-MM-dd hh:mm"
            )
          }}
        </el-descriptions-item>
        <el-descriptions-item label="售后类型">{{
          util.showSaleType(orderInfo.orderSales.saletype)
        }}</el-descriptions-item>
        <el-descriptions-item label="售后完成时间">{{
          util.formatDateUnix(
            orderInfo.orderSales.salecompleted,
            "yyyy-MM-dd hh:mm"
          )
        }}</el-descriptions-item>
        <el-descriptions-item label="售后状态">{{
          util.showSaleStatus(orderInfo.orderSales.salestatus)
        }}</el-descriptions-item>
        <el-descriptions-item label="供应商货款事宜">{{
          util.showSaleSupplieramount(orderInfo.orderSales.supplieramount)
        }}</el-descriptions-item>
        <el-descriptions-item label="售后说明">{{
          orderInfo.orderSales.salenote
        }}</el-descriptions-item>
      </el-descriptions>
      <el-divider />
      <el-descriptions title="客户信息" :column="2">
        <el-descriptions-item label="客户">{{
          orderInfo.customer.name
        }}</el-descriptions-item>
        <el-descriptions-item label="收款方式">{{
          util.showPaidWay(orderInfo.customer.paidway)
        }}</el-descriptions-item>
        <el-descriptions-item label="收款金额"
          >¥ {{ orderInfo.orderVerify.cuspaidamount }}</el-descriptions-item
        >
        <el-descriptions-item label="收款账户">{{
          orderInfo.customer.paidaccount
        }}</el-descriptions-item>
        <el-descriptions-item label="有无合同">{{
          util.showYesNo(orderInfo.customer.iscontract)
        }}</el-descriptions-item>
        <el-descriptions-item label="账期">{{
          util.supplierAccount(orderInfo.customer.isaccount)
        }}</el-descriptions-item>
        <el-descriptions-item label="客户对账时间">{{
          util.formatDateUnix(
            orderInfo.orderVerify.cuspaided,
            "yyyy-MM-dd hh:mm"
          )
        }}</el-descriptions-item>
        <el-descriptions-item label="有无开票">{{
          util.showYesNo(orderInfo.orderVerify.cusistax)
        }}</el-descriptions-item>
        <!-- <el-descriptions-item label="发票类型">{{
          util.showInvoiceType(orderInfo.orderVerify.custaxtype)
        }}</el-descriptions-item> -->
        <el-descriptions-item label="开票税点">{{
          orderInfo.customer.taxpoint
        }}</el-descriptions-item>
      </el-descriptions>
      <el-divider />
      <el-descriptions title="供应商信息" :column="2">
        <el-descriptions-item label="供应商">{{
          orderInfo.supplier.name
        }}</el-descriptions-item>
        <el-descriptions-item label="付款方式">{{
          util.showPayWay(orderInfo.supplier.payway)
        }}</el-descriptions-item>
        <el-descriptions-item label="付款金额"
          >¥ {{ orderInfo.orderVerify.suppayamount }}</el-descriptions-item
        >
        <!-- <el-descriptions-item label="付款账户">{{
          orderInfo.supplier.payaccount
        }}</el-descriptions-item> -->
        <el-descriptions-item label="有无合同">{{
          util.showYesNo(orderInfo.supplier.iscontract)
        }}</el-descriptions-item>
        <el-descriptions-item label="账期">{{
          util.supplierAccount(orderInfo.supplier.isaccount)
        }}</el-descriptions-item>
        <el-descriptions-item label="供应商对账时间">{{
          util.formatDateUnix(
            orderInfo.orderVerify.suppayed,
            "yyyy-MM-dd hh:mm"
          )
        }}</el-descriptions-item>
        <el-descriptions-item label="有无开票">{{
          util.showYesNo(orderInfo.orderVerify.supistax)
        }}</el-descriptions-item>
        <el-descriptions-item label="开票类型">{{
          util.showInvoiceType(orderInfo.supplier.taxtype)
        }}</el-descriptions-item>
        <el-descriptions-item label="开票税点">{{
          orderInfo.supplier.taxpoint
        }}</el-descriptions-item>
      </el-descriptions>
    </el-col>
  </el-row>
  <FinanceCustomer ref="RefFinanceCustomer" @click="getOrderInfos" />
  <FinanceSupplier ref="RefFinanceSupplier" @click="getOrderInfos" />

</template>
<script setup>
import { useRouter } from "vue-router";
import { ref, onMounted } from "vue";
import { getOrderInfo } from "@/api/order";
import util from "@/util/tool.js";

import FinanceCustomer from "@/components/common/financeCustomer";
import FinanceSupplier from "@/components/common/financeSupplier";


const router = useRouter();

const orderid = ref(router.currentRoute.value.params.id);
const title = ref();//router.currentRoute.value.query.name

let orderInfo = ref({
  orderid: null,
  supplierid: null,
  customerid: null,
  name: "",
  platformnum: "",
  ordernum: "",
  ordertype: "",
  saleamount: "",
  costamount: "",
  maolieamount: "",
  maoliv: "",
  maolivstatus: "",
  orderstatus: "",
  ordernote: "",
  platformed: "",
  completed: "",
  created: "",
  changed: "",
  orderSales: {
    applyed: "",
    reason: "",
    salecompleted: "",
    salenote: "",
    salestatus: "",
    saletype: "",
    supplieramount: "",
  },
  orderAddress: {
    receiver: "",
    receiverphone: "",
    receiveraddress: "",
    expressnum: "",
    expresscompany: "",
    deliveryed: "",
    freightamount: "",
    deliverynote: "",
  },
  orderGoods: {
    goodsid:"",
    goodsnum: "",
    sgoodsnum: "",
    goodsname: "",
    catalogname: "",
    brandname: "",
    specification: "",
    costprice: "",
    marketprice: "",
    discount: "",
    desc: "",
    taxcode: "",
    taxsort: "",
    barcode: "",
    erate: "",
    elink: "",
    producer: "",
    note1: "",
    note2: "",
    delivery: "",
    express: "",
  },
  orderVerify: {
    cuscompensation: "",
    cusistax: "",
    cuspaidamount: "",
    cussetstatus: "",
    cusstatus: "",
    cuspaided: "",
    custaxtype: "",
    cusnote:"",
    supcompensation: "",
    supistax: "",
    suppayamount: "",
    supsetstatus: "",
    supstatus: "",
    suppayed: "",
    suptaxtype: "",
    supnote:""
  },
  customer: {
    name: "",
    balanceway: "",
    iscontract: "",
    isaccount: "",
    paidway: "",
    paidaccount: "",
    maoliv: "",
    maolivge: "",
  },
  supplier: {
    name: "",
    balanceway: "",
    iscontract: "",
    isaccount: "",
    payway: "",
    payaccount: "",
    taxpoint: "",
    taxtype:"",
  },
});
//返回
const goback = () => {
  router.go(-1);
};

//客户对账
let dialogFinanceCustomerVisible = ref(false);
const RefFinanceCustomer = ref();
const showFinanceCustomerDialog = () => {
  RefFinanceCustomer.value.changeVisible(!dialogFinanceCustomerVisible.value);

  let amount = orderInfo.value.orderVerify.cuspaidamount?orderInfo.value.orderVerify.cuspaidamount:orderInfo.value.saleamount
  amount = orderInfo.value.orderVerify.cuscompensation? amount+orderInfo.value.orderVerify.cuscompensation:amount

  RefFinanceCustomer.value.customerMethod({
    cusstatus: orderInfo.value.orderVerify.cusstatus,
    cuscompensation: orderInfo.value.orderVerify.cuscompensation,
    cuspaidamount: amount,
    //cuspaidamount: orderInfo.value.orderVerify.cuspaidamount,
    saleamount: orderInfo.value.saleamount,
    cussetstatus: orderInfo.value.orderVerify.cussetstatus,
    cusistax: orderInfo.value.orderVerify.cusistax,
    cusnote: orderInfo.value.orderVerify.cusnote,
    orderid: orderInfo.value.orderid,
  });
};
//供应商对账
let dialogFinanceSupplierVisible = ref(false);
const RefFinanceSupplier = ref();
const showFinanceSupplierDialog = () => {
  RefFinanceSupplier.value.changeVisible(!dialogFinanceSupplierVisible.value);

  let amount = orderInfo.value.orderVerify.suppayamount?orderInfo.value.orderVerify.suppayamount:orderInfo.value.costamount
  amount = orderInfo.value.orderVerify.supcompensation? amount+orderInfo.value.orderVerify.supcompensation:amount

  RefFinanceSupplier.value.supplierMethod({
    supstatus: orderInfo.value.orderVerify.supstatus,
    supcompensation: orderInfo.value.orderVerify.supcompensation,
    // suppayamount: orderInfo.value.orderVerify.suppayamount,
    suppayamount: amount,
    costamount: orderInfo.value.costamount,
    supsetstatus: orderInfo.value.orderVerify.supsetstatus,
    supistax: orderInfo.value.orderVerify.supistax,
    supnote: orderInfo.value.orderVerify.supnote,
    orderid: orderInfo.value.orderid,
  });
};

//详情
const getOrderInfos = () => {
  getOrderInfo({ orderid: orderid.value }).then((res) => {
    orderInfo.value = res.data.extend.order;
    title.value = orderInfo.value.name;
  });
}

//onMounted方法
onMounted(() => {
  getOrderInfos()
});
</script>
<style scoped>
.el-descriptions__table {
  width: 100%;
}
.el-descriptions__label:not(.is-bordered-label) {
  width: 150px;
  display: inline-block;
}
</style>